import { mapGetters } from "vuex";

export default {
  data: () => ({
    news:[
      {
        id: 1,
        title: 'Как выбрать надежного адвоката?',
        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
        href: '/article/how-to-choose-a-reliable-lawyer',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
      {
        id: 2,
        title: 'Что такое безопасная сделка? Разбираем на примере.',
        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
        href: '/article/what-is-a-secure-transaction',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
      {
        id: 3,
        title: 'Как строить работу с адвокатом, чтобы достичь максимального результата?',
        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
        href: '/article/how-to-work-with-a-lawyer-to-achieve-maximum-results',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
      {
        id: 4,
        title: 'Лжеюристы в России.',
        text: 'В последнее время в России появилось немало коммерческих организаций, которые позиционируют себя как профессиональные юристы, проводят агрессивную рекламную компанию, заманивают людей, у которых возникла юридическая проблема, и обещают 100-процентный результат. Получив деньги, эти лже-правоведы в лучшем случае ....',
        href: '/article/lzheyuristi-v-rossii',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
      {
        id: 6,
        title: 'Что важно знать,  если вас вызвали на допрос к следователю.',
        text: 'Когда человек сознательно или интуитивно выбирает себе в жизни какую-то цель, жизненную задачу, он невольно дает себе оценку. По тому, ради чего человек живет, можно судить и о его самооценке - низкой или высокой. Только такая цель позволяет человеку прожить свою жизнь....',
        href: '/article/what-is-important-to-know-if-you-were-summoned-for-interrogation-by-the-investigator',
        img: '/static/img/imgleft.svg',
        isHide: false,
      },
    ],
    newt: {
      // title: 'Нужно ли согласие супруга на выезд ребенка за границу?',
      // text: `Значимость этих проблем настолько очевидна, что постоянное информационно-техническое обеспечение нашей деятельности обеспечивает широкому кругу специалистов участие в формировании дальнейших направлений развитая системы массового участия. Повседневная практика показывает, что дальнейшее развитие различных форм деятельности способствует подготовке и реализации позиций, занимаемых участниками в отношении поставленных задач!

      // Таким образом, сложившаяся структура организации создаёт предпосылки качественно новых шагов для дальнейших направлений развития проекта? Равным образом социально-экономическое развитие способствует повышению актуальности экономической целесообразности принимаемых решений? Практический опыт показывает, что курс на социально-ориентированный национальный проект требует от нас анализа модели развития? Не следует, однако, забывать о том, что новая модель организационной деятельности представляет собой интересный эксперимент проверки направлений прогрессивного развития.
      
      // С другой стороны консультация с профессионалами из IT представляет собой интересный эксперимент проверки системы масштабного изменения...`,
      // href: '/news',
      // img: '/static/img/imgleft.svg',
      // isHide: false,
    }
  }),

  methods: {
  },
  computed: {
    ...mapGetters([])
  },
}


// WEBPACK FOOTER //
// ./src/pages/News/news.js